import { useTranslation } from 'react-i18next';
import React, {useState} from 'react';
import ectoollogo from '../../assets/images/ectool_Logo_2019.png';
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Box, TextField, Paper, Button, Grid, IconButton, InputAdornment, Typography} from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useMessage } from '../../context/message-context';
import { FullPageSpinner } from '../lib';
import { DEBUG_FLAG } from '../../constants/debug';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import { useSessionStorage } from '../../utils/hooks';
function VerifyAdmincode({deviceId}) {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [admincode , setAdmincode] = useState('');
  const [errorMessage , setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);
  const {showSuccessMessage, showErrorMessage} = useMessage();
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
    
  const handleChange = (e) => {
    setAdmincode(e.target.value);
  }
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
        
  const admincodeCb = (response) => {
    setIsSending(false);
    if (response.status === 200) {
      showSuccessMessage(t("Freischaltung erfolgreich."));
      setErrorMessage(null);
      localStorage.setItem(LOCAL_STORAGE_KEY.private, 'true');
      setAdmincode('');
      navigate(-1);
    } else {
      if (response) {
        setErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Netzwerkfehler. Sind Sie mit dem Internet verbunden?"));
      }
    }
  }
  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (!DEBUG_FLAG() && admincode.length !== 8) {
      setErrorMessage('Der Admincode muss genau 8 Zeichen lang sein.');
      return
    }
    setIsSending(true);
    const headers={
        "Authorization": "Bearer "+accessToken,
    }
    const payload={
        "deviceId": deviceId || '',
        "admincode": admincode || ''
    }
    apiRequest('POST', 'verify/admincode', payload, headers, admincodeCb);
  }
  return(
    <Box p={2}>
    <Grid container justifyContent="center">
      <Grid item xs={12} md={8}>
      <Paper>
        <Box p={2}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <img src={ectoollogo} height="50" alt="ectool" loading="lazy"/>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5">{t("Gesicherter Bereich")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">{t("Um den gesicherten Bereich in der App freizuschalten, müssen Sie hier Ihren Admin-Code eingeben.")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Button href="https://docs.ectool.de/app/wo-finde-ich-den-admincode/#deradmincodestehtimverwendungszweckihrereletztengehaltsberweisung" color="primary" target="_blank" rel="noopener noreferrer">{t("Wo finde ich meinen Admin-Code?")}</Button>
            </Grid>
            <Grid item xs={12}>
            <form>
              <TextField
                type={showPassword ? "text" : "password"}
                label={t("Admin-Code")}
                variant="outlined"
                fullWidth
                id="admincode"
                placeholder="XXXXXXXX"
                value={admincode}
                onChange={handleChange}
                error={errorMessage}
                helperText={errorMessage}
                InputProps={{
                  endAdornment: 
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                }}
              />
              
            <Box p={1}>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={6}>
              <Button
                color="primary"
                fullWidth
                onClick={() => navigate('/')}
              >{t("Abbrechen")}</Button>
              </Grid>
              <Grid item xs={6}>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                fullWidth
                onClick={handleSubmitClick}
              >{t("Freischalten")}</Button>
              </Grid>
            </Grid>
          </form>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      </Grid>
    </Grid>
    {isSending && <FullPageSpinner/>}
    </Box>
  )
}
export default VerifyAdmincode;
